import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DoenkidsSessionProvider } from 'src/providers/session.provider';
import { IActivityProgramTemplateUsageItem, IActivityProgramTemplateUsageResponse } from 'typings/api-activity';

@Component({
  selector: 'app-activity-example-usage',
  templateUrl: './activity-example-usage.component.html',
  styleUrls: ['./activity-example-usage.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ActivityExampleUsageComponent {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly sessionProvider: DoenkidsSessionProvider,
  ) {}

  @Input() usage: IActivityProgramTemplateUsageResponse | null = null;

  @Input() loading = false;

  @Input() maxUsageCount = 3;

  get items(): IActivityProgramTemplateUsageItem[] {
    return this.usage?.items ?? [];
  }

  get shouldRender(): boolean {
    return !this.loading && this.usage !== null;
  }

  get count(): number {
    return this.items.length;
  }

  get hasReachedLimit(): boolean {
    return this.count >= this.maxUsageCount;
  }

  get remaining(): number {
    return Math.max(this.maxUsageCount - this.count, 0);
  }

  get currentOrganizationUnitId(): number | null {
    for (const routeSnapshot of [...this.activatedRoute.snapshot.pathFromRoot].reverse()) {
      const organizationUnitId = routeSnapshot.paramMap.get('ou');

      if (organizationUnitId) {
        return Number(organizationUnitId);
      }
    }

    return null;
  }

  async goToProgramTemplate(programTemplateId: number): Promise<void> {
    const organizationUnitId = this.currentOrganizationUnitId ?? await firstValueFrom(this.sessionProvider.currentOuId$);

    await this.router.navigate(['/organization', organizationUnitId, 'template', programTemplateId]);
  }
}
